import React from 'react';
import PropTypes from 'prop-types';
import { FibreAddressLine } from 'src/UI/NewPlanDetails/components/FibreAddressLine';
import './InstallationAddress.css';

const InstallationAddress = ({ address = {}, onUpdateAddress, ...props }) => {

  return (

    <div className='installation-address-container' { ...props }>

      <div className='installation-address-details'>
        { Object.keys(address).map((key) => (
          key !== 'longitude' &&
            key !== 'latitude' &&
            key !== 'docid' &&
            key !== 'formattedAddress' &&
            key !== 'seoid' &&
            key !== 'streetNumber' &&
            key !== 'streetName' ?
            <FibreAddressLine
              key={key}
              label={key}
              value={address[key]}
              onValueSave={(key1, value) => {
                onUpdateAddress({
                  key: key1,
                  value,
                });
              }}
            />
            : null
        ))}
      </div>
    </div>
  );
};

InstallationAddress.propTypes = {
  address: PropTypes.object.isRequired,
  onUpdateAddress: PropTypes.func,
};

export default InstallationAddress;
